/**
 * Where an address names a person. Inside the app, `?person` names the person on screen, so a navigation carries it on
 * to the next page. It is never carried onto the auth pages, which sign the member in or out, nor into the business
 * portal, which holds no impersonated person, so no business address names one.
 *
 * Paths are compared lowercased, because these routers resolve `/Business/acme` as the business page just as they
 * resolve `/business/acme`: a case-sensitive prefix would let `/Business/...?person=` past the portal's strip
 * (`middleware/routing.global.ts`), and the carry would then read it as a page inside the app and put the person back.
 * `packages/tracking/src/sanitize.ts` lowercases before matching its own path prefixes for the same reason.
 */

/** Whether `path` is in the business portal, where no address names a person. */
export function isBusinessPortalPath(path: string): boolean {
    return path.toLowerCase().startsWith('/business/');
}

/** Whether a navigation to `path` carries `?person`: every page inside the app except the auth pages and the business portal. */
export function addressCarriesPerson(path: string): boolean {
    return !path.toLowerCase().startsWith('/auth/') && !isBusinessPortalPath(path);
}
